import { useSelector } from 'react-redux'

import type { RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { getRecipeIdsByCoreIds } from 'selectors/menu-recipes/getRecipeIdsByCoreIds'

/**
 * Returns the recipe uuids that matches the core ids
 */
export const useRecipeIdsByCoreIds = (ids: RecipeCoreId[]): (RecipeUUID | null)[] =>
  useSelector(getRecipeIdsByCoreIds(ids))
